import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { BulkActionType } from '../types'

export const useBulkActions = (props: {
  refetchInterval?: number
  types: BulkActionType[]
}) => {
  const bulkActionsQuery = useQuery(
    dashboard20240730Client.getBulkActions,
    undefined,
    {
      refetchInterval: props.refetchInterval,
      refetchIntervalInBackground: false,
      select: res => {
        if (!res?.items) {
          return []
        }
        const allowedTypes = new Set(props.types)
        return res.items.filter(item => allowedTypes.has(item.type))
      }
    }
  )

  return {
    bulkActions: bulkActionsQuery.data ?? [],
    isLoading: bulkActionsQuery.isPending
  }
}
